import { render, staticRenderFns } from "./CareerTabs.vue?vue&type=template&id=4b8c2352&"
import script from "./CareerTabs.vue?vue&type=script&lang=js&"
export * from "./CareerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports